import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from './components/common/Navigation/Navigation';
import './App.css';
import { MapProvider } from './features/mapping/MapContext';

function App() {
  const location = useLocation();
  const isMapPage = location.pathname === '/map';
  const isNoScrollDashPage = location.pathname === '/no-scroll-dash';
  const isLandingPage = location.pathname === '/';

  return (
    <MapProvider>
      <div className={`App ${isNoScrollDashPage ? 'no-scroll-page' : ''}`}>
        <Navigation />

        <main
          className={`content
            ${isMapPage ? 'map-page-content' : ''}
            ${isLandingPage ? 'landing-page-content' : ''}
            ${isNoScrollDashPage ? 'no-scroll-dash-content' : ''}`}
        >
          <Outlet />
        </main>
      </div>
    </MapProvider>
  );
}

export default App;
